<template>
    <div>
        <div class="page-content">
            <!--            <div class="query">-->
            <!--                <el-form-->
            <!--                    label-width="80px"-->
            <!--                    :inline="true"-->
            <!--                    size="small"-->
            <!--                    class="query-form"-->
            <!--                >-->
            <!--                    <el-form-item-->
            <!--                        label="商品类型"-->
            <!--                    >-->
            <!--                        <el-select-->
            <!--                            style="width:175.6px"-->
            <!--                            v-model="productType"-->
            <!--                            size="small"-->
            <!--                            placeholder="请选择"-->
            <!--                        >-->
            <!--                            <el-option-->
            <!--                                v-for="(item,index) in productTypeEnumList"-->
            <!--                                :key="index"-->
            <!--                                :label="item.value"-->
            <!--                                :value="item.key"-->
            <!--                            > </el-option>-->
            <!--                        </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item>-->
            <!--                        <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>-->
            <!--                        <el-button size="small" icon="el-icon-refresh" @click="resetData()">重置</el-button>-->
            <!--                    </el-form-item>-->
            <!--                </el-form>-->
            <!--            </div>-->
            <div class="chart">
                <div class="my-charts" ref="saleroom"></div>
                <div class='time-box'>
                    <span :style='{ color:saleroomTimeType == 1 ? "#409EFF" : "#717171" }' @click='getSaleroom(1)'>七天</span>
                    <span :style='{ color:saleroomTimeType == 2 ? "#409EFF" : "#717171" }' @click='getSaleroom(2)'>一月</span>
                    <span :style='{ color:saleroomTimeType == 3 ? "#409EFF" : "#717171" }' @click='getSaleroom(3)'>一年</span>
                </div>
            </div>
            <div class="placeholder"></div>
            <div class="chart">
                <div class="my-charts" ref="quantity"></div>
                <div class='time-box'>
                    <span :style='{ color:quantityTimeType == 1 ? "#409EFF" : "#717171" }' @click='getQuantity(1)'>七天</span>
                    <span :style='{ color:quantityTimeType == 2 ? "#409EFF" : "#717171" }' @click='getQuantity(2)'>一月</span>
                    <span :style='{ color:quantityTimeType == 3 ? "#409EFF" : "#717171" }' @click='getQuantity(3)'>一年</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { get } from '@/utils/request';

export default {
    data(){
        return{
            // 1 周    2 月    3年
            saleroomTimeType:1, // 上方图表查询时间
            quantityTimeType:1, // 下方图表查询时间
        }
    },
    mounted(){
        this.getSaleroom()
        this.getQuantity()
    },
    methods:{
        // 上方图表数据请求
        getSaleroom(timeType = 1){
            get('/report/reportdaily/findListByType',{
                dataTypes:1,
                timeType,
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.saleroomTimeType = timeType
                    this.lineSaleroom(res.list[0])
                }
            })
        },

        // 上方图表
        lineSaleroom(list) {
            let saleroom = echarts.init(this.$refs.saleroom);
            saleroom.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                title:{
                    text:'访客数量 ',
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     },
                //     right:'30rpx'
                // },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list.map((item) => item.timeX)
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '有效',
                        type: 'line',
                        stack: 'Total',
                        data: list.map((item) => item.valueY)
                    }
                ]
            })
        },

        // 下方图表数据请求
        getQuantity(timeType = 1){
            get('/report/reportdaily/findListByType',{
                dataTypes:2,
                timeType,
                // productType:this.productType
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.quantityTimeType =timeType
                    this.lineQuantity(res.list[0])
                }
            })
        },

        // 下方图表
        lineQuantity(list) {
            let quantity = echarts.init(this.$refs.quantity);
            quantity.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                title:{
                    text:'访问数量',
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     },
                //     right:'30rpx'
                // },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list.map((item) => item.timeX)

                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '有效',
                        type: 'line',
                        // stack: 'Total',
                        data: list.map((item) => item.valueY)
                    }
                ]
            })
        },

        // 查询
        getData(){
            this.getSaleroom()
            this.getQuantity()
        },
        // 重置
        resetData(){
            this.saleroomTimeType = 1
            this.quantityTimeType = 1
            this.getData()
        },

    }
}

</script>
<style lang="scss" scoped>
.page-content{
    height: 100%;
    padding: 10px;
    background-color: #fff;

    .query{
        width: 100%;
    }

    .placeholder{
        width: 100%;
        height: 16px;
    }

    .chart{
        position: relative;
        width: 100%;
        height: 280px;
        padding: 0 22px;
        .my-charts{
            width: 100%;
            height: 100%;
        }
        .time-box{
            position: absolute;
            top: 0;
            right: 35px;
            width: 180px;
            height: 40px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            span{
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
</style>
